var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hide") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "miter",
    className: "nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M16.69,47.31A52.12,52.12,0,0,1,2.537,33.673a2.9,2.9,0,0,1-.008-3.353C5.921,25.507,16.793,12,32,12a29.018,29.018,0,0,1,15.309,4.687",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.909,20a55.426,55.426,0,0,1,9.554,10.311,2.9,2.9,0,0,1-.008,3.373C57.992,38.5,46.96,52,32,52a26.869,26.869,0,0,1-10.033-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 59,
    x2: 59,
    y2: 5,
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.321,28A12.009,12.009,0,0,1,28,43.316",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M23.519,40.485A12,12,0,0,1,40.487,23.513",
    strokeLinecap: "butt",
    stroke: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/unpublish.4f9c55e0217173991d4570e83c5e1b95.svg";
export { ForwardRef as ReactComponent };